var _defs, _polygon, _g, _path, _g2, _circle, _path2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoworkingafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .coworking_after_svg__cls-14,.coworking_after_svg__cls-15,.coworking_after_svg__cls-16,.coworking_after_svg__cls-21,.coworking_after_svg__cls-26,.coworking_after_svg__cls-27,.coworking_after_svg__cls-32,.coworking_after_svg__cls-34,.coworking_after_svg__cls-39,.coworking_after_svg__cls-40,.coworking_after_svg__cls-44,.coworking_after_svg__cls-45,.coworking_after_svg__cls-49,.coworking_after_svg__cls-53,.coworking_after_svg__cls-63,.coworking_after_svg__cls-64,.coworking_after_svg__cls-65,.coworking_after_svg__cls-68,.coworking_after_svg__cls-69,.coworking_after_svg__cls-74{stroke:#343a50}.coworking_after_svg__cls-14,.coworking_after_svg__cls-15,.coworking_after_svg__cls-16,.coworking_after_svg__cls-39,.coworking_after_svg__cls-40,.coworking_after_svg__cls-44,.coworking_after_svg__cls-45,.coworking_after_svg__cls-53,.coworking_after_svg__cls-63,.coworking_after_svg__cls-64,.coworking_after_svg__cls-65{stroke-miterlimit:10}.coworking_after_svg__cls-44,.coworking_after_svg__cls-45,.coworking_after_svg__cls-49,.coworking_after_svg__cls-53{stroke-width:2px}.coworking_after_svg__cls-4{fill:#343a50}.coworking_after_svg__cls-22,.coworking_after_svg__cls-53{fill:#fff}.coworking_after_svg__cls-51{fill:#89bb21}.coworking_after_svg__cls-12,.coworking_after_svg__cls-49{fill:#dedede}.coworking_after_svg__cls-11{mix-blend-mode:multiply}.coworking_after_svg__cls-13{fill:#eb9a6b}.coworking_after_svg__cls-14{fill:#c62a2b;stroke-width:1.58px}.coworking_after_svg__cls-15,.coworking_after_svg__cls-26{fill:#ffdccd}.coworking_after_svg__cls-15,.coworking_after_svg__cls-16,.coworking_after_svg__cls-27{stroke-width:2.02px}.coworking_after_svg__cls-16{fill:#b36375}.coworking_after_svg__cls-21,.coworking_after_svg__cls-26,.coworking_after_svg__cls-27,.coworking_after_svg__cls-32,.coworking_after_svg__cls-34,.coworking_after_svg__cls-40,.coworking_after_svg__cls-49,.coworking_after_svg__cls-68,.coworking_after_svg__cls-69,.coworking_after_svg__cls-74{stroke-linecap:round}.coworking_after_svg__cls-21,.coworking_after_svg__cls-26,.coworking_after_svg__cls-27,.coworking_after_svg__cls-32,.coworking_after_svg__cls-34,.coworking_after_svg__cls-49,.coworking_after_svg__cls-68,.coworking_after_svg__cls-69,.coworking_after_svg__cls-74{stroke-linejoin:round}.coworking_after_svg__cls-21,.coworking_after_svg__cls-27,.coworking_after_svg__cls-40{fill:none}.coworking_after_svg__cls-21,.coworking_after_svg__cls-26{stroke-width:1.34px}.coworking_after_svg__cls-23{fill:#343a51}.coworking_after_svg__cls-32{stroke-width:2.05px}.coworking_after_svg__cls-32,.coworking_after_svg__cls-34,.coworking_after_svg__cls-65,.coworking_after_svg__cls-74{fill:#ffccb5}.coworking_after_svg__cls-34{stroke-width:1.37px}.coworking_after_svg__cls-39{fill:#464655;stroke-width:.47px}.coworking_after_svg__cls-40{stroke-width:1.1px}.coworking_after_svg__cls-44{fill:#aa2020}.coworking_after_svg__cls-45{fill:#424242}.coworking_after_svg__cls-47{fill:#c67b55}.coworking_after_svg__cls-63,.coworking_after_svg__cls-64{fill:#3f3f3f}.coworking_after_svg__cls-63{stroke-width:1.58px}.coworking_after_svg__cls-64,.coworking_after_svg__cls-65,.coworking_after_svg__cls-68{stroke-width:2.19px}.coworking_after_svg__cls-68{fill:#ccdeff}.coworking_after_svg__cls-69{fill:#25364f;stroke-width:3.54px}.coworking_after_svg__cls-74{stroke-width:1.38px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Coworking_Nachher"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "coworking_after_svg__Wiese",
    fill: "#a9bf5c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "-.98 587.05 1259.02 587.05 1259 -1 -.96 -.96 -.98 587.05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Himmel"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "-1 227.82 -1 -1 333.21 -1 331.13 227.82 -1 227.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.2 0l-2.07 226.82H0V0h332.2m2-2H-2v230.82h334.12v-2L334.2 0v-2z",
    className: "coworking_after_svg__cls-4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coworking_after_svg__Wolkem",
    fill: "#fff",
    d: "M235.87 40.68c6.72-15.77 23.7-27 43.75-27 19.81 0 36.67 11 43.55 26.46a35.74 35.74 0 018.83-1.26c18.1 0 32.76 13.07 32.76 29.2S350.13 97.29 332 97.29h-85.14c-18.09 0-32.75-13.08-32.75-29.21 0-12.67 9.11-23.35 21.76-27.4z",
    opacity: 0.32
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__B\\xFCrgersteig"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#636363",
    points: "-1.02 726.6 -1 586.05 1258.98 586.05 1258.98 726.6 -1.02 726.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 587.05V725.6H0V587.05h1258m2-2H-2V727.6h1262V585.05z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1260.04,
    height: 20.75,
    x: -1.06,
    y: 726.62,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 727.62v18.75H-.06v-18.75H1258m2-2H-2.06v22.75H1260v-22.75z",
    className: "coworking_after_svg__cls-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.76,
    cy: 175.93,
    r: 125.36,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.79 178.32A125.35 125.35 0 01173.15 53c2.86 0 5.71.1 8.53.29A125.36 125.36 0 10147.23 301a125.39 125.39 0 01-99.44-122.68z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M139 542.74a6 6 0 01-4.32-1.84 5.67 5.67 0 01-1.57-4.22l10.72-156.29-32-38.32a2.44 2.44 0 01-.36-2.65 2.49 2.49 0 013.68-1.06l30.22 19.9 7.77-113.18-22.74-22.81a1.71 1.71 0 01-.38-1.89 1.75 1.75 0 011.61-1.09 1.77 1.77 0 01.77.18L154.2 230l3-43.87.17-3.46a5.66 5.66 0 0111.29-.21l2 27.64 21.61-11.44h.15a4.44 4.44 0 01.62-.05 3.31 3.31 0 012 6l-22.43 16.2 20.1 315.75a5.62 5.62 0 01-1.48 4.32 6 6 0 01-4.4 1.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163 178.33a4.49 4.49 0 014.63 4.24l2.14 29.15 22.83-12.08a2.25 2.25 0 01.44 0 2.31 2.31 0 011.36 4.15l-22.87 16.51 20.15 316.3a4.83 4.83 0 01-4.89 5.18H139a4.83 4.83 0 01-4.89-5l10.79-156.72-32.28-38.63a1.53 1.53 0 011.16-2.5 1.44 1.44 0 01.83.27l31.67 20.8 7.91-115.33-23.08-23.13a.75.75 0 01.52-1.28.84.84 0 01.33.08l23.13 11.19 3.11-45.34.18-3.48a4.51 4.51 0 014.66-4.41m0-2a6.5 6.5 0 00-6.65 6.31l-.18 3.48-2.91 42.36-20.47-9.91a2.81 2.81 0 00-1.2-.28 2.75 2.75 0 00-1.94 4.69l22.44 22.49-7.62 111-28.8-19a3.51 3.51 0 00-1.93-.6 3.56 3.56 0 00-3.2 2.07 3.48 3.48 0 00.51 3.72l31.76 38-10.7 155.97a6.66 6.66 0 001.85 5 7 7 0 005 2.15h47.79a7 7 0 005.14-2.25 6.74 6.74 0 001.74-5.11l-20.03-315.15 22-15.87a4.3 4.3 0 00-3.32-7.7l-.31.05-.28.15-20.12 10.65-1.91-26.1a6.47 6.47 0 00-6.63-6.09z",
    className: "coworking_after_svg__cls-4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "coworking_after_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 214.12l25.09-13.27a2.23 2.23 0 00-2.44-1.21l-22.83 12.08zM159.68 233.78l3.25-47.56.18-3.48a4.42 4.42 0 012.29-3.82 4.67 4.67 0 00-7 3.82l-.18 3.48-3.1 45.34zM138.87 536.73l20-292-21.77-21.82-5.1-2.54a.75.75 0 00-.85 1.2l23.08 23.13-8.63 125.16-11.45 166.87a4.83 4.83 0 004.89 5h4.73a4.83 4.83 0 01-4.9-5z",
    className: "coworking_after_svg__cls-12"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Haus"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.28 523.1 329.28 -1 1259 -.99 1259 523.1 329.28 523.1",
    className: "coworking_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28 0H1258v522.1H330.28V0m-2-2v526.1H1260V-2z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.62,
    height: 78.81,
    x: 570.14,
    y: 312.06,
    className: "coworking_after_svg__cls-14",
    rx: 9.46
  }), /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Frau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.62 377.06a16.86 16.86 0 01-.69 4.67l-8 .83q-3.43-15.82-7.33-32-1.47-6.12-3-12.14l9.4-.69a17.31 17.31 0 011.59 2.41 5.69 5.69 0 01.54 1.44l.3 1.26 4.42 19.6c.92 4.93 1.38 7.4 1.6 8.24a22.92 22.92 0 011.17 6.38zM573.16 340.1c-3.34 12.72-6.32 23.9-10.54 37l-1.53 4.67L559 379l-6.88-1a217.43 217.43 0 015-21.46c1.72-5.92 4.22-11.42 6.13-16.48z",
    className: "coworking_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.18 292.44 570.02 325.19 623.24 324.5 623.65 281.02 569.18 292.44",
    className: "coworking_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdccd",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.02,
    d: "M580.33 325.71a10.06 10.06 0 01-1.1-2.69h12v-11.64h11.54v11.94h10.35a7.62 7.62 0 010 3.18c-.79 3.64-4.2 5.59-6.07 6.67a15.41 15.41 0 01-5.87 2.09c-3.32.43-6.72-1.11-13.53-4.18-3.79-1.73-5.9-2.96-7.32-5.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.02,
    d: "M583.51 326.9c7.69 4.62 10 7.14 14.93 7.36a17.32 17.32 0 003.38-.19 22.1 22.1 0 0010.35-4.78c4.53-3.65 4.11-5.92 7.56-7a8.73 8.73 0 016.17.4 7.13 7.13 0 013.18 3 7.53 7.53 0 01.8 3.38c0 1.15 1.78.69 1.28 2.88-.32 1.41 2.32 4.75 1.84 6.64l-10.39-.37v10.55l1.6 44.55-49.21 1.74-1-56.42-10.71 1.8v-4.37c-.19-4.64 1.21-6.1 1.56-8.77.15-1.21.43-3.57 2.18-4.78 1.5-1 3.37-.75 5-.39a38.42 38.42 0 0111.48 4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.02,
    d: "M575.05 324.92a29 29 0 00-1.19-3.49h14.92l-.93 73.63H575l-1.86-51.8a10.65 10.65 0 001-1.2c4.08-5.74 1.52-14.94.91-17.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6784b3",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.02,
    d: "M621.72 342.32a8 8 0 00.89.9l1.6 50.12-15.3.54-1.72-72.45H622c-.1.28-.33 1-.6 1.92-1.34 4.75-3.99 13.95.32 18.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.64 297c-.81-.12-3.56-.44-5-1.5-.5-.37-3.55-2.65-3.08-6.07.32-2.37 3.95-4.38 6.5-5.07M620.26 285.1c.63 0 3.53-.56 4.69.29 1.91 1.41 2 3.88 2 5s.08 3.84-2.09 5.57c-1.51 1.2-5.28 1.22-5.89 1.2",
    className: "coworking_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.38 287.68a2.26 2.26 0 011.79.3 2.53 2.53 0 01.3 3.29M570.44 289a2.8 2.8 0 012.29.39c1 .84 1.2 2.78 0 4.38",
    className: "coworking_after_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.61 280.77a36.84 36.84 0 000 9c.33 2.68 1 8 4.18 13 1 1.57 7.61 11.43 19.1 11.58 8.27.11 13.89-4.89 15.22-6.08 7.13-6.35 7.82-15 8.06-17.95a29.88 29.88 0 00-.6-8.68c-.63-2.93-1-4.71-2.28-6.14-2.33-2.65-5.81-2.06-12.34-2.39-12.32-.63-12.91-3.4-19.3-1.79-1.83.46-7.83 2-10.55 7a10.94 10.94 0 00-.6 1.3z",
    className: "coworking_after_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.55 278a48.23 48.23 0 010 5.28 64.12 64.12 0 00-7.26-3.09c-2.67-.94-4.7-1.46-6.77-2-5.16-1.31-7.74-2-10.94-2.19a41.9 41.9 0 00-10.75.8 62.13 62.13 0 00-11 3 64.71 64.71 0 00-8 3.58 26.84 26.84 0 01-.7-5c-.1-2-.46-9.88 4.67-16.42a24 24 0 016-5.17 29.9 29.9 0 0114-5.77 27.06 27.06 0 0122.69 8.16 24.83 24.83 0 016.57 9.95 33 33 0 011.49 8.87z",
    className: "coworking_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.19,
    cy: 285.28,
    r: 3.46,
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.19,
    cy: 285.28,
    r: 1.82,
    className: "coworking_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.63,
    cy: 285.48,
    r: 3.46,
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.63,
    cy: 285.48,
    r: 1.82,
    className: "coworking_after_svg__cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 1.34,
    d: "M595.67 294.53a23.61 23.61 0 00-.29 2.84c-.06 1.16 0 1.58.29 1.94a2.53 2.53 0 001.27.75 2.44 2.44 0 00.9.07c.18 0 1.27-.15 1.42-.82a1.33 1.33 0 00-1-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 0.67,
    d: "M597 300.63a1 1 0 00.3.62 1 1 0 001.44-.12 1 1 0 00.2-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.55 280.36a7.07 7.07 0 013-1.5 7.4 7.4 0 014.93.67M606.87 280.36a6.23 6.23 0 012.39-1.05 6.87 6.87 0 015 1.05",
    className: "coworking_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 581.57,
    x2: 581.57,
    y1: 268.97,
    y2: 277.72,
    className: "coworking_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.11,
    x2: 591.62,
    y1: 261.5,
    y2: 275.33,
    className: "coworking_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.83,
    x2: 607.83,
    y1: 266.78,
    y2: 277.02,
    className: "coworking_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8795",
    d: "M604.38 304.72a10.46 10.46 0 01-2 1.6 9.26 9.26 0 01-6.07 1.49 8.84 8.84 0 01-5-2.41 8 8 0 01-1.09-1.31l3.09.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67984",
    d: "M591.79 304h-1.43l.22.12a17.61 17.61 0 003 1.31c1.24.37 5.38.74 10.65-.63a8.68 8.68 0 00-1.26-.52 9.38 9.38 0 00-2-.4c-2.38-.2-5.85.12-9.18.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.36 376.93c-2 1.87-2.67 4.23-3.31 6.72-.73 2.84-1.09 4.27-.63 5.53 1 2.66 4.35 4.67 6.9 4.05 3.87-1 5.07-7.67 5.39-7.67s-.12 3.51 1.31 5.93c.41.69 1 1.54 2 1.11 2-.79.94-2.05.8-3.42-.2-1.9 0-2.21-.34-3.93-.45-2.5.09-3.05-.52-4.73-.26-.72-1.75-1.61-4.73-3.37-2.57-1.51-3.3-1.83-4.27-1.71a4.74 4.74 0 00-2.6 1.49zM645.93 380c2 1.87 2.67 4.23 3.31 6.72.73 2.84 1.09 4.27.63 5.53-1 2.66-4.35 4.67-6.9 4.05-3.87-.95-5.07-7.67-5.39-7.67s.12 3.51-1.31 5.93c-.41.69-1 1.54-2 1.11-2-.79-.94-2.05-.8-3.42.2-1.9 0-2.21.34-3.93.45-2.5-.09-3 .52-4.73.26-.72 1.75-1.61 4.73-3.37 2.57-1.51 3.3-1.83 4.27-1.71a4.74 4.74 0 012.6 1.49z",
    className: "coworking_after_svg__cls-15"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12.53,
    height: 77.01,
    x: 440.5,
    y: 297,
    className: "coworking_after_svg__cls-14",
    rx: 6.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.05,
    d: "M503.48 438.9h1.64c-.54-14.15-.49-25.71-.35-33.75.26-14.32.92-22.06-.52-35.13A118.39 118.39 0 00500 348.5c-3.17-10.55-6.45-16-8.44-18.77a54.82 54.82 0 00-3.45-4.31c-2.9-3.21-3.66-3.15-7.05-6.54-3.57-3.56-4.11-5-5.69-5-1.85 0-3.19 2-4.82 4.47-6 9.15-9 13.73-9.47 14.81a65.82 65.82 0 00-4.7 14.84c-1.82 9.79-.36 14.51-.34 30.65 0 6.08-.2 11-.35 13.95l.7 45.28c.61 0 1.57.08 2.75.18a86.39 86.39 0 0110.86 1.53c4.36.86 14.34 2.83 22.38.86a47 47 0 0111.1-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.05,
    d: "M472.05 308a4.93 4.93 0 01-2.58-.34c-2.12-1-2.77-3.49-3.27-5-1.48-4.42-2.72-3.32-7.75-11.88-2.38-4-3.57-6.07-4.31-8.26-2.67-7.93-.26-17.55 4.65-24.28 6.33-8.67 15.61-10.94 18.77-11.71 6.34-1.55 11.79-.92 21.35.17a123.39 123.39 0 0112.4 2.07 18.45 18.45 0 00-3.79 1.37 18.7 18.7 0 00-4.47 3.1l12.39.52a11.17 11.17 0 010 2.24c-.54 5.64-5.07 9.22-5.85 9.81-5 3.83-8.06.81-11.88 3.62-5.65 4.15-.44 11.79-6.55 22.9-2.22 4.08-5.16 6.67-11.16 11.91a14.4 14.4 0 01-7.95 3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.21 306.31a83 83 0 008.19 4.28l.42.2c3.86 1.73 7.33 3 11 2.41a5.06 5.06 0 002.24-1 8.76 8.76 0 003.1-4.3 23.27 23.27 0 001.05-11.28c0-.07-.16-.44 0-.61s.32-.09.4-.08a7.07 7.07 0 002.84-.2 2 2 0 001.1-1 2.34 2.34 0 00.06-1.62 5.11 5.11 0 00-1-2.06 8.93 8.93 0 01-1.13-1.77s0-.18-.12-.4l-.17-.44a12.39 12.39 0 01-.49-1.93 14.11 14.11 0 01.25-7.92 20.11 20.11 0 00.43-7.67 7.83 7.83 0 00-7-7.31c-.88-.2-5.56-1.1-8.44 1.72a8.79 8.79 0 00-1.89 3.44c-1.8 4.58-.81 5.92-2.24 9.47-1 2.53-3.2 6-5.68 6a2.65 2.65 0 01-1.72-.52c-.79-.63-.64-1.48-1.55-3.61a4.35 4.35 0 00-.86-1.55 3.69 3.69 0 00-4.14 0c-1.25.8-1.58 2.17-1.89 3.44a12.28 12.28 0 00.34 6.54c.68 2.14 1.43 2.65 1.72 4.82a11 11 0 010 2.93c-.44 3.82-2.05 7.52-3.09 10.16-2.47 6.23-3.93 10-2.24 12 .35.43.57.44 2.11 1.17 4.11 1.95 4.34 2.71 8.13 4.65 1.41.71 6.86 3.49 7.62 2.45.22-.3-.05-.78-.39-1.55a20.86 20.86 0 01-1.42-6.33c-.47-3.93.58-6.84 1-6.84.09 0 3 .35 3.29.32l1.61.09s-.66 0 1.2-.06",
    className: "coworking_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37,
    d: "M501.14 278.35a4.06 4.06 0 012.27-1.42 4.19 4.19 0 013.39.85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.97,
    cy: 283.44,
    className: "coworking_after_svg__cls-22",
    rx: 2.83,
    ry: 2.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.47,
    cy: 284.05,
    className: "coworking_after_svg__cls-4",
    rx: 0.99,
    ry: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.17 301a13.52 13.52 0 002.07 1.38 13.94 13.94 0 006.54 1.63M478.59 282.63a3.56 3.56 0 011.3 1.29 4.29 4.29 0 01-.13 3.88",
    className: "coworking_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.59 394.48a7.28 7.28 0 01-3.32.53 7.14 7.14 0 01-1.1-.19c-3-.79-12.72-1.77-24.8-4.48q-3-.68-5.85-1.38s-.21-2.23-.34-3.44c-.28-2.49-.61-4.31-.69-4.82-.34-2-.69-7.06-.69-20.32l-16.19 1.37c.12 13.5-.12 21.76-.69 25.83a16.28 16.28 0 00.35 6.89 17.84 17.84 0 002.06 4.48c2.52 3.82 23.33 7.07 52 7.23l1 .53c4.84 2.63 5.36 3.5 7.69 4.55 1.9.85 4.43 2 7.17 1.13a7.8 7.8 0 003.32-2.18c3.56-3.61 3.63-8.79 3.58-10.49",
    className: "coworking_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707484",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.65,
    d: "M523.59 396.32l7.75 9.33a3.09 3.09 0 004.15.49l20.63-15a2.64 2.64 0 00.52-3.87l-7.75-9.34a3.1 3.1 0 00-4.14-.49l-20.64 15a2.65 2.65 0 00-.52 3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2232",
    d: "M528.76 393.88l6.39 7.68a2.37 2.37 0 003.18.38l14.9-10.84a2 2 0 00.4-3l-6.39-7.69a2.36 2.36 0 00-3.18-.37l-14.9 10.83a2 2 0 00-.4 3.01z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.47 382l2.08 2.68-2.68 2.09-2.09-2.68 2.69-2.09m0-.45l-3.14 2.45 2.48 3.19 3.19-2.49-2.48-3.19z",
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 542.39,
    y: 383.56,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.4 543.307 381.595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81 388.83l2.08 2.68-2.68 2.09-2.09-2.68 2.69-2.09m.05-.45l-3.19 2.48 2.48 3.19 3.19-2.48-2.48-3.19z",
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 547.74,
    y: 390.44,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 548.509 391.206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.6 387.3l2.08 2.68-2.68 2.09-2.09-2.69 2.69-2.08m0-.45l-3.19 2.48 2.48 3.19 3.19-2.48-2.48-3.19z",
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 535.51,
    y: 388.9,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 536.282 389.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.93 394.17l2.09 2.68-2.68 2.09-2.09-2.69 2.68-2.08m.06-.45l-3.19 2.48 2.48 3.19 3.19-2.48-2.47-3.19z",
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 540.85,
    y: 395.77,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 541.626 396.525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.75 387.63l2.47 3.17-3.17 2.46-2.46-3.16 3.16-2.47m.06-.45l-3.68 2.82 2.86 3.68 3.68-2.86-2.86-3.68z",
    className: "coworking_after_svg__cls-22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 541.62,
    y: 389.68,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 542.395 390.437)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 539.16,
    y: 391.58,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 539.932 392.339)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 544.08,
    y: 387.76,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 544.854 388.524)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 539.71,
    y: 387.21,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 540.483 387.978)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 543.54,
    y: 392.13,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 544.308 392.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 537.71,
    y: 387.19,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 538.484 387.956)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 540.19,
    y: 385.27,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 540.963 386.034)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 543.26,
    y: 394.33,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 544.03 395.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 545.74,
    y: 392.41,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 546.508 393.173)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 536.96,
    y: 391.3,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 537.732 392.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 538.89,
    y: 393.78,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 539.654 394.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 544.36,
    y: 385.56,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.4 545.276 383.585)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.57,
    height: 1.57,
    x: 546.29,
    y: 388.04,
    className: "coworking_after_svg__cls-22",
    transform: "rotate(52.15 547.054 388.803)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 529.97,
    cy: 398.82,
    r: 1.3,
    fill: "#464655",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.92,
    height: 0.96,
    x: 550.57,
    y: 381.75,
    className: "coworking_after_svg__cls-39",
    rx: 0.48,
    transform: "rotate(-127.85 552.542 382.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.43,
    cy: 384.59,
    r: 0.49,
    className: "coworking_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "533.48 394.3 531.35 391.81 534.1 389.75",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "541.2 398.07 538.47 400.12 536.32 397.61",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "550.75 386.8 552.9 389.31 550.14 391.38",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "543.02 383.06 545.79 380.99 547.9 383.46",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "539.83 391.63 539.11 390.8 540.03 390.12",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "542.4 392.9 541.49 393.58 540.77 392.74",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "545.59 389.13 546.31 389.97 545.38 390.66",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "543.01 387.88 543.93 387.19 544.64 388.02",
    className: "coworking_after_svg__cls-40"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.28,
    cy: 385.19,
    fill: "#fe0000",
    rx: 0.52,
    ry: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.05,
    d: "M464.48 349.7q.22 5.87.86 12.23c.2 2 .44 3.94.69 5.85l19.28-.94 5.51-.26 5.17-.52v-5c-.08-7.75-.51-15.16-1.2-22.22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Uhr"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M629.38 80.27a64.26 64.26 0 1022.72 124.37V84.41a64.15 64.15 0 00-22.72-4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 205.69A61.17 61.17 0 11652.1 87.75v-6.62a67.35 67.35 0 100 126.78v-6.61a60.91 60.91 0 01-22.72 4.39z",
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.18,
    x2: 629.18,
    y1: 80.27,
    y2: 90.3,
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.18 93.39a3.09 3.09 0 01-3.08-3.09v-10a3.09 3.09 0 116.17 0v10a3.09 3.09 0 01-3.09 3.09z",
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 565.12,
    x2: 575.15,
    y1: 144.2,
    y2: 144.22,
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.15 147.31h-10a3.09 3.09 0 010-6.17h10a3.09 3.09 0 110 6.17z",
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.06,
    x2: 629.08,
    y1: 208.4,
    y2: 198.36,
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.06 211.48a3.08 3.08 0 01-3.08-3.09v-10a3.09 3.09 0 013.09-3.09 3.09 3.09 0 013.08 3.1v10a3.07 3.07 0 01-3.09 3.08z",
    className: "coworking_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 189a1.74 1.74 0 01-1.74-1.74v-40.88a1.74 1.74 0 013.47 0v40.91a1.73 1.73 0 01-1.73 1.71z",
    className: "coworking_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 144.11c-.83-.49-1.75-.46-2.06.07l-13 22.26c-.31.52.12 1.34.94 1.82s1.75.46 2.06-.07l13-22.26c.33-.52-.1-1.34-.94-1.82z",
    className: "coworking_after_svg__cls-45"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.18,
    cy: 144.33,
    r: 3.09,
    className: "coworking_after_svg__cls-45"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 232.17,
    height: 292.56,
    x: 420.3,
    y: 65.87,
    fill: "#7fc3ca",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.5 358.14 523.5 225.39 421.3 225.39 421.3 199.63 523.5 199.63 523.5 66.87 549.28 66.87 549.28 199.63 651.48 199.63 651.48 225.39 549.28 225.39 549.28 358.14 523.5 358.14",
    className: "coworking_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.28 67.87v132.76h102.2v23.76h-102.2v132.76h-23.77V224.39H422.3v-23.76h102.21V67.87h23.77m2-2h-27.77v132.76H420.3v27.76h102.21v132.75h27.77V226.39h102.2v-27.76h-102.2V65.87z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.28 523.1V-1h412.59v524.1zm92-165h230.2V67H421.31z",
    className: "coworking_after_svg__cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28 0h410.59v522.1H330.28V0m90 359.15h232.2V66H420.31v293.15M328.28-2v526.1h414.59V-2zm94 359.15V68h228.2v289.15z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b27052",
    points: "867.34 93.78 1239.97 93.78 1239.97 522.31 867.34 523.1 867.34 93.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 94.78v426.53l-370.63.79V94.78H1239m2-2H866.34V524.1l374.63-.79V92.78z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "902.21 119.93 1200.04 119.93 1200.04 522.31 902.21 523.1 902.21 119.93",
    className: "coworking_after_svg__cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199 120.93v400.39l-295.83.78V120.93H1199m2-2H901.21V524.1l299.83-.79V118.93z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 868.5,
    x2: 901.99,
    y1: 95.04,
    y2: 120.16,
    className: "coworking_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1238.63,
    x2: 1199.24,
    y1: 94.98,
    y2: 120.19,
    className: "coworking_after_svg__cls-49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 187.96,
    height: 378.71,
    x: 959.67,
    y: 144.4,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1047.29 523.1 1047.3 426.3 959.68 426.3 959.68 413.56 1047.3 413.56 1047.3 326.47 959.68 326.47 959.68 313.73 1047.3 313.73 1047.3 228.15 959.67 228.15 959.67 215.41 1047.29 215.41 1047.28 144.41 1060 144.41 1060.02 215.41 1147.63 215.41 1147.63 228.15 1060.02 228.15 1060.02 313.73 1147.63 313.73 1147.63 316.36 1147.64 316.36 1147.64 324.78 1147.63 326.47 1060.02 326.47 1060.02 413.56 1147.63 413.56 1147.63 426.3 1060.02 426.3 1060.02 523.1 1047.29 523.1",
    className: "coworking_after_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 145.41v71h87.61v10.74H1059v87.58h87.61v10.69H1059v89.09h87.61v10.79H1059v96.8h-10.72v-96.8h-87.6v-10.74h87.61v-89.09h-87.61v-10.74h87.61v-87.58h-87.61v-10.74h87.61v-71H1059m2-2h-14.72v71h-87.6v14.74h87.61v83.58h-87.61v14.74h87.61v85.09h-87.61v14.74h87.61v96.8H1061v-96.8h87.61v-14.74H1061v-85.09h87.61V312.73H1061v-83.58h87.61v-14.74H1061v-71z",
    className: "coworking_after_svg__cls-4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1157.14 570.52h-3.09c-18.15 0-32.91-9.37-32.91-20.9 0-9.42 9.79-17.53 23.74-20.07-3.72-3.45-5.73-7.55-5.73-11.8 0-9.42 9.66-17.51 23.71-20.07a13.28 13.28 0 01-.61-4c0-10.2 11.21-18.7 26.84-20.52.92-11 15.31-19.78 32.86-19.78a52 52 0 018.88.76C1237 448.42 1247 445 1258 445a47.67 47.67 0 0117.55 3.2c5.62-5 14.59-8.21 24.32-8.66 6.1-5.85 16.29-9.33 27.42-9.33 17.68 0 32.14 8.9 32.88 20 11.17 1.75 20.18 7.19 23.52 14.18 15.81 0 29 6.93 32.15 16.63 15.65.23 28.61 7.22 31.5 16.91 13.13 2.94 21.88 10.78 21.88 19.7 0 5-2.65 9.61-7.51 13.33 10.84 3.56 17.67 10.62 17.67 18.54 0 9.52-10.11 17.83-24.59 20.21h-.12l-295.92.67a15.85 15.85 0 01-1.61.14z",
    className: "coworking_after_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.28 431.75c17.35 0 31.41 8.69 31.41 19.41v.41c11.85 1.52 21.22 7.17 24.06 14.4h.92c15.83 0 28.89 7.23 31.06 16.64h.36c15.85 0 28.92 7.26 31.07 16.68 12.53 2.55 21.59 9.83 21.59 18.43 0 5.44-3.65 10.36-9.5 13.88 11.52 2.88 19.66 9.84 19.66 18 0 9-9.91 16.53-23.34 18.73l-295.86.67c-.52 0-1 .07-1.53.07-1 0-2-.07-3.09-.07-17.35 0-31.41-8.69-31.41-19.4 0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.79 0-9.2 10.36-16.88 24.25-18.88a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.07-19.4 31.41-19.4a49.48 49.48 0 019.36.88c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3m0-3c-11.26 0-21.63 3.48-28 9.36-9.6.54-18.17 3.55-24 8.4a49.72 49.72 0 00-17.25-3c-11 0-21.19 3.33-27.63 9a53 53 0 00-8.41-.66c-18 0-32.38 8.58-34.21 19.94-15.79 2.21-27 11.15-27 21.86a14.75 14.75 0 00.27 2.8c-13.92 3-23.37 11.43-23.37 21.23a16.78 16.78 0 004.28 10.89c-13.23 3.2-22.29 11.45-22.29 21 0 12.56 15.11 22.4 34.41 22.4h3.09c.53 0 1.15 0 1.66-.07l295.74-.67h.48c15.22-2.5 25.85-11.42 25.85-21.69 0-7.95-6.2-15.07-16.23-19.07 3.95-3.7 6.07-8.11 6.07-12.8 0-9.45-8.86-17.73-22.22-21-3.48-9.66-16.22-16.59-31.6-17.11-3.79-9.58-16.78-16.38-32.28-16.65-3.72-6.87-12.24-12-23.07-14-1.64-11.5-16.1-20.22-34.26-20.22z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "coworking_after_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136.63 558.56c0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.8 0-9.19 10.36-16.87 24.25-18.87a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.72 14.07-19.4 31.42-19.4a50.22 50.22 0 019.35.87c5.54-5.51 15.4-9.19 26.68-9.19a45.6 45.6 0 0117.86 3.46c5.27-5.11 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3a47.75 47.75 0 0114.44 2.18c-5-6.6-15.84-11.19-28.43-11.19-11.35 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.84-24.65 8.94a45.78 45.78 0 00-17.86-3.45c-11.28 0-21.14 3.68-26.68 9.19a49.48 49.48 0 00-9.36-.88c-17.34 0-31.41 8.69-31.41 19.4v.23c-15.16 1.38-26.81 9.43-26.81 19.17a12.6 12.6 0 001.15 5.15c-13.89 2-24.25 9.68-24.25 18.88 0 4.9 3 9.37 7.84 12.79-14.69 1.62-25.85 9.54-25.85 19.08 0 7.5 6.89 14 17 17.22a13.55 13.55 0 01-3.01-8.21z",
    className: "coworking_after_svg__cls-12"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-1.5 1081.5 -1.56 744.87 1259.44 744.87 1259.44 1081.5 -1.5 1081.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.94 746.37V1080H0l-.06-333.63h1258m3-3h-1264v3L-3 1080v3h1263.94V743.37z",
    className: "coworking_after_svg__cls-4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Busch-2",
    "data-name": "Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9 554h-3.09c-18.15 0-32.91-9.38-32.91-20.9 0-9.43 9.79-17.54 23.74-20.07-3.72-3.46-5.73-7.56-5.73-11.81 0-9.41 9.66-17.5 23.71-20.06a13.66 13.66 0 01-.61-4c0-10.2 11.21-18.7 26.84-20.53.92-11 15.31-19.77 32.87-19.77a51 51 0 018.87.76c6.13-5.7 16.2-9.08 27.16-9.08a47.88 47.88 0 0117.55 3.2c5.62-5 14.59-8.2 24.32-8.66 6.11-5.85 16.3-9.32 27.42-9.32 17.68 0 32.15 8.9 32.88 20 11.18 1.75 20.19 7.18 23.52 14.17 15.81 0 29.05 6.94 32.15 16.64 15.65.23 28.61 7.21 31.5 16.91 13.13 2.93 21.88 10.77 21.88 19.69 0 5-2.64 9.61-7.51 13.33 10.84 3.5 17.67 10.6 17.67 18.5 0 9.52-10.11 17.83-24.59 20.21h-.12l-295.92.68c-.5.11-1.01.11-1.6.11z",
    className: "coworking_after_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 415.23c17.35 0 31.41 8.69 31.41 19.4v.41c11.84 1.52 21.21 7.17 24.05 14.4h.93c15.82 0 28.88 7.24 31.05 16.64h.36c15.85 0 28.93 7.26 31.07 16.69 12.53 2.55 21.59 9.83 21.59 18.42 0 5.45-3.65 10.37-9.5 13.89 11.52 2.87 19.66 9.84 19.66 18 0 9-9.91 16.53-23.33 18.73l-295.87.68c-.52.05-1 .06-1.53.06-1 0-2-.06-3.09-.06-17.35 0-31.41-8.69-31.41-19.41 0-9.54 11.16-17.45 25.85-19.08-4.86-3.41-7.84-7.88-7.84-12.79 0-9.19 10.36-16.87 24.25-18.88a12.59 12.59 0 01-1.15-5.14c0-9.75 11.65-17.79 26.81-19.17v-.23c0-10.72 14.07-19.4 31.42-19.4a49.39 49.39 0 019.35.87c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.56 24.65-8.93 5.52-5.57 15.43-9.3 26.78-9.3m0-3c-11.26 0-21.62 3.48-28 9.35-9.59.55-18.17 3.56-24 8.41a49.72 49.72 0 00-17.25-3c-11 0-21.18 3.33-27.63 9a52.9 52.9 0 00-8.4-.66c-18 0-32.39 8.57-34.22 19.93-15.79 2.21-27 11.15-27 21.87a14.83 14.83 0 00.27 2.8c-13.92 3-23.37 11.43-23.37 21.22a16.79 16.79 0 004.28 10.9C36.47 515.24 27.4 523.5 27.4 533c0 12.57 15.11 22.41 34.41 22.41h3.09c.6 0 1.15 0 1.67-.06l295.73-.68h.48c15.22-2.5 25.85-11.42 25.85-21.7 0-7.95-6.2-15.06-16.23-19.06 4-3.7 6.07-8.11 6.07-12.81 0-9.45-8.85-17.72-22.22-21-3.47-9.66-16.21-16.6-31.59-17.12-3.8-9.58-16.79-16.37-32.29-16.65-3.72-6.87-12.24-12-23.07-14-1.64-11.5-16.1-20.22-34.26-20.22z",
    className: "coworking_after_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "coworking_after_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.39 542c0-9.54 11.16-17.45 25.86-19.08-4.87-3.41-7.84-7.88-7.84-12.79 0-9.19 10.35-16.87 24.25-18.88a12.6 12.6 0 01-1.16-5.14c0-9.75 11.65-17.79 26.82-19.17a2 2 0 010-.23c0-10.72 14.06-19.41 31.41-19.41a49.56 49.56 0 019.36.88c5.54-5.51 15.4-9.19 26.67-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.53-5.56 15.44-9.29 26.78-9.29a47.44 47.44 0 0114.44 2.18c-5-6.61-15.84-11.19-28.43-11.19-11.34 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.83-24.65 8.93a45.78 45.78 0 00-17.88-3.43c-11.28 0-21.13 3.68-26.68 9.19a49.39 49.39 0 00-9.35-.87c-17.35 0-31.42 8.68-31.42 19.4v.23c-15.16 1.38-26.81 9.42-26.81 19.17a12.44 12.44 0 001.16 5.14c-13.9 2-24.26 9.69-24.26 18.88 0 4.91 3 9.38 7.84 12.79-14.67 1.64-25.83 9.55-25.83 19.07 0 7.49 6.9 14 17 17.21a13.53 13.53 0 01-3.01-8.21z",
    className: "coworking_after_svg__cls-12"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363.06,
    height: 55.08,
    x: 872.06,
    y: 12.28,
    className: "coworking_after_svg__cls-53"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#343a50",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 48,
    transform: "matrix(1.04 0 0 1 885.7 55.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.01em"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.31,
    y: 0,
    letterSpacing: "-.01em"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.33,
    y: 0,
    letterSpacing: "-.01em"
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.18,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.53,
    y: 0,
    letterSpacing: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 130.42,
    y: 0,
    letterSpacing: ".02em"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.74,
    y: 0,
    letterSpacing: 0
  }, "ing Pfaff")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.9,
    height: 23.62,
    x: 1.1,
    y: 960.57,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 401.72,
    y: 960.57,
    className: "coworking_after_svg__cls-53"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 802.89,
    y: 960.57,
    className: "coworking_after_svg__cls-53"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.48,
    height: 23.62,
    x: 1204.65,
    y: 960.57,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.99
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_after_svg__Mann"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M986.65 530.56a11.63 11.63 0 00-1.12 5v3l41.15.61a7.06 7.06 0 00-.4-2.12c-1-2.85-3.69-4.22-5.36-5.06-3.54-1.76-7-2-10.31-2.22-2.81-.19-3.32 0-5.16-.41-3.16-.79-3.29-1.92-6.17-2.83-.95-.3-5.25-1.65-9.1.51a8.88 8.88 0 00-3.53 3.52z",
    className: "coworking_after_svg__cls-63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.25 525.77a18.42 18.42 0 00-2.22 6l-.44 2.42-.25 1.39 40.35 8.1a11.65 11.65 0 00.09-2.75 11.17 11.17 0 00-4.13-7.31c-3.07-2.84-6.4-3.75-9.64-4.63-2.72-.74-3.27-.52-5-1.43-2.93-1.56-2.8-3-5.42-4.66-.87-.55-4.79-3-9.07-1a10.24 10.24 0 00-4.27 3.87z",
    className: "coworking_after_svg__cls-63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "952.03 512.08 973.77 516.02 972.14 525.01 961.11 528.09 955 525.08 952.44 522.77 952.03 512.08",
    className: "coworking_after_svg__cls-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.41 528.19a192.21 192.21 0 01-5-59L992.35 458a45 45 0 017.93 12.18c4 9.07 3.22 16.12 3 35.57-.07 5-.12 12.81 0 22.47",
    className: "coworking_after_svg__cls-65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "982.58 518.35 1004.68 518.35 1004.68 527.48 994.38 532.48 987.82 530.61 984.9 528.79 982.58 518.35",
    className: "coworking_after_svg__cls-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.59 522.19a180 180 0 01.42-32.27 178.1 178.1 0 014.84-26.72l14.59-8.78a45.19 45.19 0 016.23 13.5c2.57 9.69.53 16.48-3.19 35.58-1 4.94-2.41 12.58-4 22.11",
    className: "coworking_after_svg__cls-65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3e5887",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.37,
    points: "974.25 369.85 1006.11 368.2 1003.48 452.09 1004.68 478.53 1005.45 526.42 996.07 527.6 988 528.19 983.74 529.01 980.46 496.36 957.37 411.44 956.59 375.47 974.25 369.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5887",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.72,
    d: "M960.53 429.49c-1.7 30.14-7.74 63-7.82 63.59-.09.75-3.36 21.24-3.36 21.24s-.92 5.83-1 7.42c10.87 2.11 16.36 2.57 27.23 4.68 1.87-10.78 4.1-25.63 6-36.4 1.14-7.79 5-22.32 5.19-35.6.13-7.77 1.63-5.51.78-11.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.42 375.57c0-13.4 1.17-27.15 1.17-40.55 0-12.28.88-23.77 1.55-36.14 0 0 .69-12.76 8.24-28.24a16.07 16.07 0 016.34-7.26c7.69-4.78 19.91-3.06 25.38 3.35a24.11 24.11 0 015 10.77c.24 1.27 4.6 24.74 4.81 26.07 2.39 15.05 5.28 32.11 5.77 55.25.12 5.88.07 10.72 0 14l-45 1.67z",
    className: "coworking_after_svg__cls-68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.15 397.1a18.66 18.66 0 013.75-15.1 14.37 14.37 0 0122.1-1.45 18.69 18.69 0 015.51 13.45l-8.54-.07a10.12 10.12 0 00-2.93-7.3 6.7 6.7 0 00-4.64-2.07 6.85 6.85 0 00-4.85 2.77 10.14 10.14 0 00-2 8.23z",
    className: "coworking_after_svg__cls-69"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.21,
    height: 55.97,
    x: 938.71,
    y: 393.84,
    className: "coworking_after_svg__cls-69",
    rx: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccb5",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.19,
    d: "M970.65 368.45c-2.38 3.06-2.71 6.46-3 10-.35 4.09-.52 6.13.4 7.77 2 3.44 7.07 5.44 10.44 4 5.13-2.2 5.24-11.74 5.67-11.81s.64 4.86 3.17 7.87c.72.86 1.69 1.9 3 1.07 2.51-1.55.82-3.05.31-4.9-.71-2.58-.56-3-1.38-5.35-1.19-3.34-.57-4.22-1.79-6.4-.53-.94-2.79-1.82-7.3-3.55-3.89-1.5-5-1.77-6.29-1.38a6.68 6.68 0 00-3.23 2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.05 281.77c-.64 5.87-1.86 13.33-2.21 19.41-.78 13.52-.48 23.82 0 40.45.18 6.34.48 14.85 1 24.95l22 3.39c0-16.48.23-30.14.5-40.45.19-6.82-.09-14 .39-23 .35-6.58.9-19.4 1.18-24",
    className: "coworking_after_svg__cls-68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.19,
    d: "M976.83 252.73a5.06 5.06 0 01-2.63-.21c-2.19-.86-3-3.37-3.57-4.86-1.74-4.38-2.93-3.2-8.48-11.57-2.62-4-3.93-5.93-4.79-8.1-3.13-7.86-1.23-17.7 3.36-24.76 5.91-9.1 15.15-11.9 18.3-12.85 6.32-1.91 10.93-1.41 20.64-.82l7.74 2 2.85.77 3.15 1.81h0a10.69 10.69 0 01.86 4.63v.46c-.24 5.73-1.08 8.19-1.84 8.84-4.86 4.13-8.09 1.26-11.79 4.3-5.47 4.5.2 11.92-5.35 23.47-2 4.21-4.9 7-10.65 12.61-1.01.99-3.89 3.73-7.8 4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccb5",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92,
    d: "M987 250.43a83.25 83.25 0 008.5 3.88l.43.17c4 1.54 7.56 2.66 11.26 1.83a5.11 5.11 0 002.2-1.17 8.88 8.88 0 002.89-4.51 23.61 23.61 0 00.45-11.45c0-.07-.2-.43 0-.61s.31-.11.39-.1a7.27 7.27 0 002.86-.36 2.08 2.08 0 001.05-1 2.41 2.41 0 000-1.64 5.31 5.31 0 00-1.16-2 8.5 8.5 0 01-1.23-1.71l-.15-.4-.19-.43a12 12 0 01-.61-1.93 21.08 21.08 0 01-.66-4.06 19.06 19.06 0 01.49-3.95 20.34 20.34 0 000-7.76 7.92 7.92 0 00-7.44-7c-.9-.15-5.67-.8-8.42 2.2a8.9 8.9 0 00-1.72 3.58c-1.57 4.72-.49 6-1.74 9.68-.89 2.6-2.91 6.24-5.41 6.39a2.69 2.69 0 01-1.76-.42c-.83-.6-.73-1.46-1.77-3.57a4.27 4.27 0 00-1-1.51 3.73 3.73 0 00-4.17.22c-1.22.89-1.48 2.28-1.72 3.58a12.54 12.54 0 00.7 6.59c.81 2.12 1.59 2.59 2 4.77a11.47 11.47 0 01.17 2.95c-.25 3.88-1.67 7.71-2.58 10.43-2.14 6.42-3.41 10.36-1.59 12.29.38.4.6.4 2.19 1 4.26 1.74 4.53 2.51 8.46 4.25 1.46.65 7.12 3.15 7.83 2.06.2-.32-.1-.78-.48-1.54a21.08 21.08 0 01-1.78-6.31c-.69-3.95.21-6.94.67-7 .09 0 3 .2 3.34.15h1.64c-.01 0-.67.08 1.2-.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M1004.56 221.17a4.1 4.1 0 012.21-1.55 4.26 4.26 0 013.48.67"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1007.7,
    cy: 226.16,
    className: "coworking_after_svg__cls-22",
    rx: 2.86,
    ry: 2.15,
    transform: "rotate(-3.11 1007.262 226.042)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1008.23,
    cy: 226.74,
    className: "coworking_after_svg__cls-4",
    rx: 1,
    ry: 1.43,
    transform: "rotate(-3.11 1007.8 226.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.81 244.11a13.54 13.54 0 002.16 1.28 14.25 14.25 0 006.7 1.29M982 226.73a3.65 3.65 0 011.37 1.23 4.33 4.33 0 01.09 3.92",
    className: "coworking_after_svg__cls-74"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoworkingafter);
export default __webpack_public_path__ + "static/media/coworking.after.82045e8d.svg";
export { ForwardRef as ReactComponent };